import { AB_CREATIVE_EXTENSION } from "@/constants/ABMng";
import useABTest from "@/utils/hooks/useABtest";
import NewPurePinCard from "./newCard";
import OldPurePinCard from "./oldCard";

export default function PinCard(props) {
  const creativeExtensionAB = useABTest(AB_CREATIVE_EXTENSION);

  if (creativeExtensionAB.new) {
    return <NewPurePinCard {...props} />;
  }
  return <OldPurePinCard {...props} />;
}
